var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSinglescaleOn = function SvgSinglescaleOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.197 8.631H28.139l-6.94 6.816 12.97 12.811 12.97-12.811zm-10.832 3h9.605l2.361 2.319H27.004zm-2.376 5.32h14.357l-7.179 7.091zM7.902 19.742l-6.94 6.816 12.97 12.811 12.97-12.811-6.94-6.816zm1.227 3h9.605l2.361 2.319H6.767zm-2.376 5.319H21.11l-7.179 7.091z"
  })))));
};
export default SvgSinglescaleOn;